<template>
  <div>
    <b-row>
      <h4>Revendedoras Indicadas</h4>
    </b-row>
    <b-row align-v="end">
      <b-col class="col-2">
        <label>Nome:</label>
        <b-form-input size="sm" v-model="filtro.nome" placeholder="Nome da revendedora"></b-form-input>
      </b-col>
      <b-col class="col-1" v-if="!distribuidor.codigo">
        <label>Estado:</label>
        <b-form-select size="sm" v-model="filtro.estado" :options="estados"></b-form-select>
      </b-col>
      <b-col class="col-2">
        <label>Cidade:</label>
        <b-form-select size="sm" v-model="filtro.cidade" :options="cidades"></b-form-select>
      </b-col>
      <b-col class="col-1" v-if="!distribuidor.codigo">
        <label>Status:</label>
        <b-form-select size="sm" v-model="filtro.status" :options="optionsStatus"></b-form-select>
      </b-col>
      <b-col class="col-2">
        <label>De:</label>
        <b-input-group>
          <b-form-input size="sm" v-model="filtro.de.dataFormatada" type="text" placeholder="DD/MM/YYYY"
            autocomplete="off" v-mask="['##/##/####']" />
          <b-input-group-append>
            <b-form-datepicker size="sm" v-model="filtro.de.data" button-only right locale="pt-br"
              @context="onContext(filtro.de, 'de')" />
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col class="col-2">
        <label>Até:</label>
        <b-input-group>
          <b-form-input size="sm" v-model="filtro.ate.dataFormatada" type="text" placeholder="DD/MM/YYYY"
            autocomplete="off" v-mask="['##/##/####']" />
          <b-input-group-append>
            <b-form-datepicker size="sm" v-model="filtro.ate.data" button-only right locale="pt-br"
              @context="onContext(filtro.ate, 'ate')" />
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col class="col-2">
        <b-button variant="primary" size="sm" @click="buscar()" title="Filtrar"><i class="fas fa-search"></i>
          Filtrar</b-button>
        <b-button size="sm" :disabled="loadingExportar" variant="success" @click="exportar()"
          title="Exportar para Excel">
          <i class="fas fa-file-excel" v-if="!loadingExportar"></i>
          <b-spinner v-else variant="primary" small label="Spinning"></b-spinner>
          Exportar
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="col-2">
        <span v-if="totalRows > 0">Total de Registros: {{ totalRows }}</span>
      </b-col>
      <b-col class="col-8">
        <b-pagination v-if="totalRows > 14" v-model="currentPage" @input="loadRevendedoras()" :total-rows="totalRows"
          :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
      </b-col>
      <b-col>
        <b-form-group label="Registros por página" label-for="per-page-select" label-cols-sm="6" label-cols-md="4"
          label-cols-lg="8" label-align-sm="right" label-size="sm" class="mb-0">
          <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
            autofocus></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="row mt-3">
      <div class="col">
        <b-card class="p-3">
          <b-table :items="tableData" :busy="loading" :fields="colunas" stacked="md"
            empty-text="Nenhum dado para exibir" show-empty>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>
            <template #cell(id)="data">
              <b-button v-if="distribuidor.codigo" variant="primary">
                <i class="fa fa-edit" @click="modalImporta(data.item)"></i>
              </b-button>
                <div v-else>
                  <span v-if="data.item.distribuidor_id" class="text-success font-weight-bold" style="border-radius: 8px; border: 2px solid #2ab27b;padding: 5px;"
                  >Importado</span>
                  <span v-else class="text-warning font-weight-bold" style="border-radius: 8px; border: 2px solid #ffaf00;padding: 5px;">Pendente</span>
                </div>
              <!-- ##VERSÃO ANTERIOR ## <div v-else>
                {{ data.item.distribuidor_id ? "Importado" : "Pendente" }}
              </div> -->
            </template>
          </b-table>
          <b-row> </b-row>
        </b-card>
      </div>
    </div>

    <!-- MODAL DE IMPORTACAO DO PRE-CADASTRO DE REVENDEDORA -->
    <b-modal v-model="modalImport" size="xl">
      <b-card>
        <b-card-body v-if="modalImport">
          <form-revendedora :lista_revendedoras="renvendedoras" :revendedora="precadastro"
            :meu_estado="distribuidor.endereco.cidade.estado.uf" :classe_distribuidor="distribuidor.classe"
            ref="revendedora">
          </form-revendedora>
        </b-card-body>
      </b-card>
      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="saveRevendedora">
          Salvar
        </b-button>
        <b-button variant="danger" size="sm" @click="modalImport = false">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FormRevendedora from "../../revendedora/form.vue";

export default {
  components: {
    FormRevendedora,
  },
  data() {
    return {
      tabIndex: 0,
      loadingExportar: false,
      filtro: {
        cidade: null,
        nome: "",
        estado: null,
        status: null,
        de: {
          data: "",
          dataFormatada: "",
        },
        ate: {
          data: "",
          dataFormatada: "",
        },
      },
      cidades: [],
      formatted: "",
      selected: "",
      estados: [],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 30, 60, 80, 100],
      sortBy: "nome",
      sortDesc: false,
      sortDirection: "asc",
      modalImport: false,
      precadastro: {},
      distribuidor: {},
      renvendedoras: [],
      filter: null,
      filterOn: [],
      optionsStatus: [
        { value: null, text: "Todos" },
        { value: "IMPORTADO", text: "Importado" },
        { value: "PENDENTE", text: "Pendente" },
      ],
      colunas: [
        {
          key: "nome",
          label: "NOME",
          formatter: (value) => {
            return value ? value.trim() : "";
          },
        },
        {
          key: "email",
          label: "EMAIL",
          formatter: (value) => {
            return value ? value.trim() : "";
          },
        },
        {
          key: "telefone_1",
          label: "CONTATO",
          formatter: (value, key, item) => {
            let contato = "";
            if (item.telefone_1) {
              contato = item.telefone_1;
            }
            if (item.telefone_2 && item.telefone_2 !== item.telefone_1) {
              contato = contato + ", " + item.telefone_2;
            }
            return contato;
          },
        },
        {
          key: "estado",
          label: "ESTADO",
          formatter: (value) => {
            return value ? value.trim() : "";
          },
        },
        {
          key: "cidade",
          label: "CIDADE",
          formatter: (value) => {
            return value ? value.trim() :"";
          },
        },
        {
          key: "bairro",
          label: "BAIRRO",
          formatter: (value) => {
            if (value == null) {
              return '-';
            }
            return value ? value.trim() :"";
          },
        },
        {
          label: "CRIAÇÃO",
          key: "created_at",
          class: "text-center",
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          key: "id",
          label: "IMPORTAR",
        },
      ],
      loading: false,
    };
  },
  watch: {
    "filtro.estado"() {
      if (this.filtro.estado) {
        this.getCidades();
      } else {
        this.cidades = [];
      }
    }
  },
  methods: {
    getCidades() {
      const vm = this;
      if (vm.filtro.estado) {
        vm.loading = true;
        axios.get('/cidades/' + this.filtro.estado)
          .then((response) => {
            vm.cidades = [{ value: null, text: "Todas" }]
            response.data.forEach((el) => {
              vm.cidades.push({ value: el.id, text: el.nome })
            })
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            vm.loading = false
          })
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    exportar() {
      const vm = this;
      vm.loadingExportar = true;
      const data = {
        filtro: vm.filtro,
      };
      axios({
        method: "post",
        url: "/revendedoras_indicadas/exportar",
        responseType: "blob",
        data: data,
      })
        .then((response) => {
          let file = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(file);
          let a = document.createElement("a");
          a.href = url;
          a.download = Date.now() + ".xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((erro) => {
          console.log(erro);
          vm.$swal("Atenção", erro, "error");
        })
        .finally(() => {
          $(".loading").hide();
          vm.loadingExportar = false;
        });
    },
    buscar() {
      this.currentPage = 1;
      this.loadRevendedoras();
    },
    loadRevendedoras() {
      const vm = this;
      vm.loading = true;
      const data = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        filtro: this.filtro,
      };
      vm.tableData = [];
      axios
        .get("/revendedoras_indicadas", { params: data })
        .then((response) => {
          vm.tableData = response.data.data;
          vm.totalRows = response.data.total;
          vm.currentPage = response.data.current_page;
          vm.loading = false;
        })
        .catch((error) => {
          console.log(error);
          vm.loading = false;
          alert("Não foi possível carregar as revendedoras indicadas");
        });
    },

    listaRevendedoras() {
      const lista = axios.get("/distribuidor/revendedora/listar");
      if (lista) {
        this.renvendedoras = lista.data;
      }
    },

    modalImporta(objEdit) {
      const pre_cadastroid = objEdit.id;
      this.precadastro = objEdit;
      this.precadastro.id = null;
      this.precadastro.status = 1;
      this.precadastro.precadastro_id = pre_cadastroid;
      this.precadastro.desconto = 30;
      this.precadastro.contatos = [
        {
          tipo: "F",
          numero: objEdit.telefone_1,
          whatsapp: 0,
        },
        {
          tipo: "M",
          numero: objEdit.telefone_2,
          whatsapp: 1,
        },
      ];
      this.modalImport = true;
    },

    getMyProfile() {
      const vm = this
      axios
        .get("/my-profile")
        .then((response) => {
          vm.distribuidor = response.data.profile;
          if (vm.distribuidor.codigo) {
            vm.filtro.estado = vm.distribuidor.endereco.cidade.estado.uf;
          }
        })
        .catch((erro) => {
          console.log(erro);
        })
        .finally(() => {
          $(".loading").hide();
        });
    },

    saveRevendedora() {
      this.$refs.revendedora.saveRevendedora();
      if (this.$refs.revendedora.valida) {
        this.loadRevendedoras();
        this.modalImport = false;
        this.$swal("OK", "Salvo com sucesso", "success");
      }
    },
    async getEstados() {
      const vm = this;
      vm.estados = [];
      await axios.get("/estados")
        .then((response) => {
          vm.estados = [{ value: null, text: "TODOS" }];
          let obj = response.data;
          obj.forEach((a, b) => {
            vm.estados.push({
              value: a.uf,
              text: a.uf,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
          $(".loading").hide();
        });
    },
    onContext(ctx, tipo) {
      let dataFormatada = moment(ctx.data).format("DD/MM/YYYY");
      if (tipo == "ate") {
        this.filtro.ate.dataFormatada = dataFormatada;
      }
      if (tipo == "de") {
        this.filtro.de.dataFormatada = dataFormatada;
      }
    },
  },

  mounted() {
    this.getMyProfile();
    this.loadRevendedoras();
    this.getEstados();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/indicados/revendedoras_indicadas/Main.vue